const ScheduleTitle = ({ record }) => {
    return <span>Schedule {record ? `"${record.id}"` : ''}</span>;
};

export default ScheduleTitle;